import React from 'react';

const Arrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8.619" viewBox="0 0 16 8.619">
    <path id="Path_390" data-name="Path 390" d="M18.514,12.719,14.2,8.41v3.571H2.514v1.476H14.2v3.571Z" transform="translate(-2.514 -8.41)" fill="#fff" />
  </svg>
);

export default Arrow;
